import { useState, useRef, useContext } from "react";
import Loader from "../Loader";
import AuthContext from "../../Contexts/Auth/AuthContext";
import { useNavigate } from "react-router-dom";
import classes from "./Profile.module.css";
import UseFetch from "../CustomHooks/useFetch";
const Profile = () => {
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);

  // const firstNameRef = useRef();
  // const lastNameRef = useRef();
  // const emailRef = useRef();
  const currentPasswordRef = useRef();
  const newPasswordRef = useRef();
  const confirmPasswordRef = useRef();
  const profileRef = useRef();

  const defaultValidationStateForProfileUpdate = {
    firstName: { invalid: false, message: "Please enter first name" },
    lastName: { invalid: false, message: "Please enter last name" },
    email: { invalid: false, message: "Please enter email" },
  };

  const defaultValidationStateForPasswordUpdate = {
    currentPassword: { invalid: false, message: "Please enter current password" },
    newPassword: { invalid: false, message: "Please enter new password" },
    confirmPassword: { invalid: false, message: "Please enter confirm password" },
  };

  const [validateValues, setValidateValues] = useState(
    defaultValidationStateForProfileUpdate
  );

  const [validatePasswordValues, setValidatePasswordValues] = useState(
    defaultValidationStateForPasswordUpdate
  );

  const [response, setResponse] = useState(null);
  const [passwordResponse, setPasswordResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingPassword, setIsLoadingPassword] = useState(false);
  const [userValues, setUserValues] = useState({
    firstName: authContext?.userInfo?.first_name,
    lastName: authContext?.userInfo?.last_name,
    email: authContext?.userInfo?.email,
    profilePic: authContext?.userInfo?.profile_pic
  });
  const [passwordFields, setPasswordFields] = useState({
    currentPassword: { field: "password", icon: "fa fa-eye" },
    newPassword: { field: "password", icon: "fa fa-eye" },
    confirmPassword: { field: "password", icon: "fa fa-eye" },
  });
  // const [profilePic, setProfilePic] = useState('');

  const isEmpty = (value) => !value || value.trim().length === 0;

  const submitHandler = async (event) => {
    setValidateValues(defaultValidationStateForProfileUpdate);
    event.preventDefault();

    // const firstName = firstNameRef.current.value;
    // const lastName = lastNameRef.current.value;
    // const email = emailRef.current.value;
    const firstName = userValues.firstName;
    const lastName = userValues.lastName;
    const email = userValues.email;
    const profilePic = userValues.profilePic;
    // const password = passwordRef.current.value;

    let isValid = true;

    if (isEmpty(firstName)) {
      setValidateValues((prevState) => {
        return {
          ...prevState,
          firstName: { ...prevState.firstName, invalid: true },
        };
      });
      isValid = false;
    }

    if (isEmpty(lastName)) {
      setValidateValues((prevState) => {
        return {
          ...prevState,
          lastName: { ...prevState.lastName, invalid: true },
        };
      });
      isValid = false;
    }

    if (isEmpty(email)) {
      setValidateValues((prevState) => {
        return { ...prevState, email: { ...prevState.email, invalid: true } };
      });
      isValid = false;
    }

    // if(isEmpty(password)) {
    //   setValidateValues((prevState) => {
    //     return {...prevState, password: {...prevState.firstName, invalid: true}}
    //   });
    //   isValid = false;
    // }

    const formData = {};
    // const formData = new Object();

    if (isValid) {
      setIsLoading(true);

      formData.firstName = firstName;
      formData.lastName = lastName;
      formData.email = email;
      formData.profilePic = profilePic || '';
      Object.freeze(formData);

      console.table(formData);

        // const {responseData, error, isLoading} = UseFetch("http://localhost:3001/auth/profile-update", {
        //   method: "POST",
        //   headers: {
        //     "Content-Type": "application/json",
        //     Authorization: "Bearer " + authContext.token,
        //   },
        //   body: JSON.stringify(formData),
        // });

        // if(isLoading) {
        //   setIsLoading(true);
        // } else if (error) {
        //   if (error.status === 422) {
        //     console.table(error.errors.errors);
        //     for (const key of error.errors.errors) {
        //       setValidateValues((prevState) => {
        //         return {
        //           ...prevState,
        //           [key.path]: { message: [key.msg], invalid: true },
        //         };
        //       });
        //     }
        //   } else {
        //     setResponse((prevState) => {
        //       return { success: false, message: error.errors.message };
        //     });
        //   }
        //   setIsLoading(false);
        // } else {
        //   setResponse((prevState) => {
        //     return { success: true, message: responseData.message };
        //   });
        //   setIsLoading(false);
        // }


        try {
        const response = await fetch(
          process.env.REACT_APP_EXPRESS_URL + "/auth/profile-update",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + authContext.token,
            },
            body: JSON.stringify(formData),
          }
        );

        if (!response.ok) {
          if(response.status === 401) {
            localStorage.removeItem('linkedin-scheduler-token');
            return window.location.href="/login";
          }
          const error = await response.json();

          if (response.status === 422) {
            console.table(error.errors);
            for (const key of error.errors) {
              setValidateValues((prevState) => {
                return {
                  ...prevState,
                  [key.path]: { message: [key.msg], invalid: true },
                };
              });
            }
          } else {
            setResponse((prevState) => {
              return { success: false, message: error.message };
            });
          }

          return;
        }
        const data = await response.json();

        setResponse((prevState) => {
          return { success: true, message: data.message };
        });

        
      } catch (error) {
        setResponse((prevState) => ({
          success: false,
          message: "Something went wrong. Please try again.",
        }));
      } finally {
        setIsLoading(false);
        setTimeout(() => {
          setResponse(null);
          authContext.setFetchUserInfoAgain(true);
        }, 3000);
      }
    }
  };

  const changeHandler = (event) => {
    setUserValues((prevState) => {
      return { ...prevState, [event.target.id]: event.target.value };
    });
  };

  const passwordUpdateHandler = async (event) => {
    setValidatePasswordValues(defaultValidationStateForPasswordUpdate);
    event.preventDefault();

    const currentPassword = currentPasswordRef.current.value;
    const newPassword = newPasswordRef.current.value;
    const confirmPassword = confirmPasswordRef.current.value;

    let isValidPassword = true;

    if (isEmpty(currentPassword)) {
      setValidatePasswordValues((prevState) => {
        return {
          ...prevState,
          currentPassword: { ...prevState.currentPassword, invalid: true },
        };
      });
      isValidPassword = false;
    }

    if (isEmpty(newPassword)) {
      setValidatePasswordValues((prevState) => {
        return {
          ...prevState,
          newPassword: { ...prevState.newPassword, invalid: true },
        };
      });
      isValidPassword = false;
    }

    if (isEmpty(confirmPassword)) {
      setValidatePasswordValues((prevState) => {
        return {
          ...prevState,
          confirmPassword: { ...prevState.confirmPassword, invalid: true },
        };
      });
      isValidPassword = false;
    }

    const formData = {};

    if (isValidPassword) {
      setIsLoadingPassword(true);

      formData.currentPassword = currentPassword;
      formData.newPassword = newPassword;
      formData.confirmPassword = confirmPassword;
      Object.freeze(formData);

      console.table(formData);

      try {
        const response = await fetch(
          process.env.REACT_APP_EXPRESS_URL + "/auth/password-update",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + authContext.token,
            },
            body: JSON.stringify(formData),
          }
        );

        if (!response.ok) {
          if(response.status === 401) {
            localStorage.removeItem('linkedin-scheduler-token');
            return window.location.href="/login";
          }
          const error = await response.json();

          if (response.status === 422) {
            console.table(error.errors);
            for (const key of error.errors) {
              setValidatePasswordValues((prevState) => {
                return {
                  ...prevState,
                  [key.path]: { message: [key.msg], invalid: true },
                };
              });
            }
          } else {
            setPasswordResponse((prevState) => {
              return { success: false, message: error.message };
            });
          }

          return;
        }
        const data = await response.json();

        setPasswordResponse((prevState) => {
          return { success: true, message: data.message };
        });
      } catch (error) {
        setPasswordResponse((prevState) => ({
          success: false,
          message: "Something went wrong. Please try again.",
        }));
      } finally {
        setIsLoadingPassword(false); // Disable loader after receiving response (regardless of success or error)
        setTimeout(() => {
          setPasswordResponse(null);
          closeAlert();
          localStorage.removeItem('linkedin-scheduler-token');
          return window.location.href="/login";
        }, 3000);
      }
    }
  };

  const PasswordFieldHandler = (id) => {
    setPasswordFields((prevState) => {
      return {
        ...prevState,
        [id]: {
          field: prevState[id].field === "password" ? "text" : "password",
          icon:
            prevState[id].field === "password"
              ? "fa fa-eye-slash"
              : "fa fa-eye",
        },
      };
    });
    // setPasswordFields((prevState) => {
    //   return {...prevState, id: {field : prevState.id.field === 'password' ? 'text' : 'password', icon: prevState.id.field === 'password' ? 'fa fa-eye-slash' : 'fa fa-eye'}}
    // })
  };

  const profilePicChangeHandler = async (event) => {
    // console.log(event.target.files[0]);
    const file = event.target.files[0];

    const formData = new FormData();
    formData.append('image', file);
  
    try {
      const response = await fetch(
        process.env.REACT_APP_EXPRESS_URL + "/api/upload-profile-pic",
        {
          method: "POST",
          headers: {
            Authorization: "Bearer " + authContext.token,
          },
          body: formData,
        }
      );

      if (!response.ok) {
        const error = await response.json();
       
        setResponse((prevState) => {
          return { success: false, message: error.message };
        });

        return;
      }

      const data = await response.json();

      setUserValues((prevState) => {
        return { ...prevState, profilePic: data.imageUrl };
      });

    } catch (error) {
      alert('error');
      setResponse((prevState) => ({
        success: false,
        message: "Something went wrong. Please try again.",
      }));
    } finally {
      // setIsLoading(false);
      // setTimeout(() => {
      //   setResponse(null);
      // }, 3000);
    }
    // console.log(URL.createObjectURL(file));
    // setUserValues((prevState) => {
    //   return { ...prevState, profilePic: URL.createObjectURL(file) };
    // });    
    // setProfilePic(URL.createObjectURL(file));
  }

  const closeAlert = () => setResponse(null) || setPasswordResponse(null);

  return (
    <div className="min-h-screen bg-gray-900 text-white p-6 pt-22">
      {/* PAGE HEADER */}
      <div className="content-header mb-1">
        <div className="container-fluid">
          <div className="flex flex-wrap justify-between items-center">
            <h4 className="text-l font-semibold">Profile</h4>
            <div className="text-l text-gray-400 md:mt-0">
              <button type="button" className="text-blue" onClick={() => navigate("/panel/dashboard")}>Home</button>
              <span> / Profile</span>
            </div>
            {/* <ol className="flex space-x-2 text-sm text-gray-400">
              <li>
                <button
                  type="button"
                  className="text-blue-400 hover:underline"
                >
                  Home
                </button>
              </li>
              <li>/</li>
              <li className="text-white">Profile</li>
            </ol> */}
          </div>
        </div>
      </div>

      <div className="container-fluid">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* PROFILE INFORMATION FORM */}
          <div className="bg-gray-800 p-6 rounded-lg shadow">
            <h3 className="text-lg font-semibold mb-4">Profile</h3>
            {isLoading && <Loader />}
          {response && (
            <div
              className={`relative px-4 py-3 mb-2 rounded-lg text-sm border transition-opacity duration-500 ease-in-out ${
                response.success
                  ? 'bg-green-100 text-green-600 border-green-300'
                  : 'bg-rose-100 text-rose-600 border-rose-300'
              }`}
            >
              <span>{response.message}</span>
              <button
                className="absolute right-2 top-2 text-xl text-gray-500 hover:text-gray-700"
                onClick={closeAlert}
                aria-label="Close"
              >
                &times;
              </button>
            </div>
          )}
            <form onSubmit={submitHandler} className="space-y-4">

              <div className="flex justify-center">
                <div className="text-center">
                  <input type="file" id="profile_pic_input" className="hidden" ref={profileRef}
                            onChange={profilePicChangeHandler}/>
                  <div>
                    <img
                      src={userValues.profilePic}
                      className="w-20 h-20 rounded-full object-cover border border-gray-600 cursor-pointer"
                      alt="Profile"
                    />
                  </div>
                  <div className="mt-3">
                    <button
                      type="button"
                      onClick={() => profileRef.current.click()}
                      className="text-sm bg-blue-600 hover:bg-blue-700 transition text-white px-3 py-1 rounded"
                    >
                      Change
                    </button>
                  </div>
                </div>
              </div>
              <div>
                <label className="block mb-1 text-sm text-gray-300">First Name</label>
                <input
                  type="text"
                  className="w-full px-4 py-2 rounded-lg bg-gray-700 border border-gray-600 text-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
                  id="firstName"
                  placeholder="Enter first name"
                  value={userValues.firstName}
                  onChange={changeHandler}
                />
                {validateValues.firstName.invalid && (
                <span className="text-rose-400 text-sm mt-1 block">{validateValues.firstName.message}</span>
                )}
                {/* <span className="text-sm text-red-400">First name error message</span> */}
              </div>
              <div>
                <label className="block mb-1 text-sm text-gray-300">Last Name</label>
                <input
                  type="text"
                  className="w-full px-4 py-2 rounded-lg bg-gray-700 border border-gray-600 text-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
                  id="lastName"
                  placeholder="Enter last name"
                  value={userValues.lastName}
                  onChange={changeHandler}
                />
                {validateValues.lastName.invalid && (
                <span className="text-rose-400 text-sm mt-1 block">{validateValues.lastName.message}</span>
                )}
              </div>
              <div>
                <label className="block mb-1 text-sm text-gray-300">Email</label>
                <input
                  type="email"
                  className="w-full px-4 py-2 rounded-lg bg-gray-700 border border-gray-600 text-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
                  id="email"
                  placeholder="Enter email"
                  value={userValues.email}
                  onChange={changeHandler}
                />
                {validateValues.email.invalid && (
                <span className="text-rose-400 text-sm mt-1 block">{validateValues.email.message}</span>
                )}
              </div>
              <div>
                <button
                  type="submit"
                  className="bg-blue-600 text-sm text-white px-3 py-1 rounded hover:bg-blue-700 transition"
                >
                  Update
                </button>
              </div>
            </form>
          </div>

          {/* PASSWORD FORM */}
          <div className="bg-gray-800 p-6 rounded-lg shadow">
            <h3 className="text-lg font-semibold mb-4">Change Password</h3>
            {isLoading && <Loader />}
            {passwordResponse  && (
              <div
                className={`relative px-4 py-3 mb-2 rounded-lg text-sm border transition-opacity duration-500 ease-in-out ${
                  passwordResponse .success
                    ? 'bg-green-100 text-green-600 border-green-300'
                    : 'bg-rose-100 text-rose-600 border-rose-300'
                }`}
              >
                <span>{passwordResponse.message}</span>
                <button
                  className="absolute right-2 top-2 text-xl text-gray-500 hover:text-gray-700"
                  onClick={closeAlert}
                  aria-label="Close"
                >
                  &times;
                </button>
              </div>
            )}
            <form onSubmit={passwordUpdateHandler} className="space-y-4">
              <div>
                <label className="block mb-1 text-sm text-gray-300">Current Password</label>
                <div className="flex items-center bg-gray-700 border border-gray-600 rounded-lg focus-within:ring-2 focus-within:ring-blue-500">
                  <input
                    type={passwordFields.currentPassword.field}
                    id="currentPassword"
                    ref={currentPasswordRef}
                    className="w-full px-4 py-2 rounded-lg bg-gray-700 border border-gray-600 text-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    placeholder="Enter current password"
                  />
                  <div
                  className="px-3 text-gray-400 cursor-pointer"
                  onClick={() => PasswordFieldHandler("currentPassword")}
                  >
                    <i className={passwordFields.currentPassword.icon}></i>
                  </div>
                </div>
              </div>
              {validatePasswordValues.currentPassword.invalid && (
                <span className="text-rose-400 text-sm mt-1 block">{validatePasswordValues.currentPassword.message}</span>
              )}
              <div>
                <label className="block mb-1 text-sm text-gray-300">New Password</label>
                <div className="flex items-center bg-gray-700 border border-gray-600 rounded-lg focus-within:ring-2 focus-within:ring-blue-500">
                  <input
                    type={passwordFields.newPassword.field}
                    id="newPassword"
                    ref={newPasswordRef}
                    className="w-full px-4 py-2 rounded-lg bg-gray-700 border border-gray-600 text-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    placeholder="Enter new password"
                  />
                  <div
                  className="px-3 text-gray-400 cursor-pointer"
                  onClick={() => PasswordFieldHandler("newPassword")}
                  >
                    <i className={passwordFields.newPassword.icon}></i>
                  </div>
                </div>
                {validatePasswordValues.newPassword.invalid && (
                <span className="text-rose-400 text-sm mt-1 block">{validatePasswordValues.newPassword.message}</span>
                )}
              </div>
              <div>
                <label className="block mb-1 text-sm text-gray-300">Confirm Password</label>
                <div className="flex items-center bg-gray-700 border border-gray-600 rounded-lg focus-within:ring-2 focus-within:ring-blue-500">
                  <input
                    type={passwordFields.confirmPassword.field}
                    id="confirmPassword"
                    ref={confirmPasswordRef}
                    className="w-full px-4 py-2 rounded-lg bg-gray-700 border border-gray-600 text-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    placeholder="Enter confirm password"
                  />
                  <div
                  className="px-3 text-gray-400 cursor-pointer"
                  onClick={() => PasswordFieldHandler("confirmPassword")}
                  >
                    <i className={passwordFields.confirmPassword.icon}></i>
                  </div>
                </div>
                {validatePasswordValues.confirmPassword.invalid && (
                <span className="text-rose-400 text-sm mt-1 block">{validatePasswordValues.confirmPassword.message}</span>
                )}
              </div>
              <div>
                <button
                  type="submit"
                  className="bg-blue-600 text-white text-sm px-3 py-1 rounded hover:bg-blue-700 transition"
                >
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
